import axios from 'axios';
import store from '../store'
import verifyAuth from '../services/utilities'

class FundingRepository {

    constructor() {
        this.basePath = store.state.backend;
    }

    createFundingTest(fundingTest) {
        let headers = { 'Authorization': store.state.token };
        let response = axios.post(`${this.basePath}/ext/funding-challenge-test`, fundingTest, { headers: headers });
        response = verifyAuth(response)
        return response;
    }

    allFundingEvaluationsByMarket(market) {
        let headers = { 'Authorization': store.state.token };
        let response = axios.get(`${this.basePath}/ext/funding-evaluations/market/${market}`, { headers: headers });
        response = verifyAuth(response)
        return response;
    }

    allFundingTestOfUser() {
        let headers = { 'Authorization': store.state.token };
        let url = (store.state.whitelabel !== null && store.state.whitelabel.partner !== null) ?
            `${this.basePath}/ext/funding-challenge-test/user/by-partner?partnerId=${store.state.whitelabel.partner.id}` :
            `${this.basePath}/ext/funding-challenge-test/user`;
        let response = axios.get(url, { headers: headers });
        response = verifyAuth(response)
        return response;
    }

    fundingTestOverview(fundingTestId) {
        let headers = { 'Authorization': store.state.token };
        let response = axios.get(`${this.basePath}/ext/funding-challenge-test/overview/${fundingTestId}`, { headers: headers });
        response = verifyAuth(response)
        return response;
    }

    abandonFundingTest(fundingTestId) {
        let headers = { 'Authorization': store.state.token };
        let response = axios.get(`${this.basePath}/ext/funding-challenge-test/abandon/${fundingTestId}`, { headers: headers });
        response = verifyAuth(response)
        return response;
    }

    fundingSummaryByUser(userId) {
        let headers = { 'Authorization': store.state.token };
        let response = axios.get(`${this.basePath}/ext/funding-tests/user/${userId}/summary`, { headers: headers });
        response = verifyAuth(response)
        return response;
    }

    challengesByMarket(market) {
        let headers = { 'Authorization': store.state.token };
        let response = axios.get(`${this.basePath}/ext/funding-challenges/market/${market}`, { headers: headers });
        response = verifyAuth(response)
        return response;
    }
    fundingTestOverviewPublic(fundingTestId, brokerIdentifier) {
        let response = axios.get(`${this.basePath}/ext/funding-challenge-test/summary/${fundingTestId}/${brokerIdentifier}`);
        return response;
    }
}

export default new FundingRepository();
